<template>
  <div>
    <v-dialog v-model="dialog" max-width="1024">
      <v-card>
        <v-toolbar
          tile
          card
          flat
          dense
          color="theme_primary"
          class="white--text"
        >
          <v-spacer></v-spacer>
          <v-toolbar-title class="white-text text-capitalize">
            Password update of {{ user.first_name }}
            {{ user.last_name }}</v-toolbar-title
          >

          <v-spacer></v-spacer>
          <v-toolbar-side-icon>
            <v-icon color="white">lock</v-icon>
          </v-toolbar-side-icon>
        </v-toolbar>
        <v-card-text>
          <div v-for="field in inputFields" :key="field.name">
            <v-text-field
              autocomplete="nothingplease"
              @change="fillObject(field, $event)"
              :label="fetchLabel(field)"
              background-color="white"
              box
              type="password"
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" flat="flat" @click="dialog = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" flat="flat" @click="update">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn flat round fab small @click="openDialog" color="#888">
      <v-icon>lock</v-icon>
    </v-btn>
  </div>
</template>

<script>
import gql from "graphql-tag";
import pluralize from "pluralize";

export default {
  data() {
    return {
      dialog: false,
      inputFields: {},
      passwordObject: {},
    };
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openDialog() {
      this.fetchInputFields();
      this.dialog = true;
    },
    fetchLabel(field) {
      return field.description
        ? field.description
        : this.camelize(field.name, " ");
    },
    fillObject(field, item) {
      this.passwordObject[field.name] = item;
    },
    camelize(str, sep = "", plural = false) {
      return pluralize(
        str
          .split("_")
          .map((w) => w.replace(/./, (m) => m.toUpperCase()))
          .join(sep),
        plural ? 2 : 1
      );
    },
    update() {
      const mutation = gql`
          mutation {
            update_password_user(
              id: "${this.user.id}"
              user: {
                current_password: "${this.passwordObject.current_password}"
                new_password: "${this.passwordObject.new_password}"
                new_password_confirmation: "${this.passwordObject.new_password_confirmation}"
              }
            ) { id }
          }
        `;
      this.sendMutation("updated password", "user", mutation).then(() => {
        this.dialog = false;
      });
    },
    fetchInputFields() {
      const query = gql`
        {
          __type(name: "PasswordInputType") {
            name
            description
            inputFields {
              name
              description
              type {
                name
                kind
              }
            }
          }
        }
      `;
      this.sendQuery(query).then((data) => {
        this.inputFields = data.__type.inputFields;
      });
    },
  },
};
</script>
